module.exports = __webpack_public_path__ + "static/images/routeSummary/noDataForThisRoute.svg";